import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import {Checkbox} from "primereact/checkbox";
import {Dialog} from "primereact/dialog";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const SendConfirmationView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Reportes \ Préstamos Históricos \ Enviar Confirmación"/>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: "right"}}>
                        <Button label="Agregar Correo"
                                onClick={props.openNewEmailDialog}
                                className="p-button-secondary"/>&nbsp;
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnHistoricalReports}
                        />&nbsp;
                        <Button
                            label="Enviar"
                            onClick={props.sendEmail}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/> <br/>
                        <SubtitleLabel header="Incluir correos" isBold={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <Grid container direction="row" justify="space-evenly">
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                            className={"secondary-text"}>
                                    <Checkbox name="ptm"
                                              checked={props.confirmationData.ptm}
                                              onChange={props.onChangeConfirmationData}/>
                                    &nbsp; Prestamista
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                            className={"secondary-text"}>
                                    <Checkbox name="ptt"
                                              checked={props.confirmationData.ptt}
                                              onChange={props.onChangeConfirmationData}/>
                                    &nbsp; Prestatario
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.dataConfirmationEmails}
                            selectionMode="single"
                            onSelectionChange={props.handleSelectEmail}
                            selection={props.emailSelected}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                        >
                            <Column field="correoElectronico" header="Correo Electrónico" style={{textAlign: 'left'}}
                                    sortable={true}/>
                            <Column field="rol" header="Rol" style={{textAlign: 'left'}} sortable={true}/>
                            <Column header="Acciones" body={props.emailConfirmationActionTemplate}
                                    style={{textAlign: 'right', width: '8em'}} />
                        </DataTable>
                    </Grid>

                    <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                            onHide={props.onHideDialog} closable={false} style={{width: '40%'}}>
                        <div className="p-grid p-fluid">
                            <div className="p-col-12" style={{padding: '.75em'}}>
                                <label htmlFor="emailStr" className={"secondary-text"}><b>Correo Electrónico</b></label>
                            </div>
                            <div className="p-col-12" style={{padding: '.5em'}}>
                                <InputText name="correoElectronico"
                                           maxLength={100}
                                           onChange={props.onChangeConfirmationData}
                                           value={props.confirmationData.correoElectronico}
                                           placeholder="Ex. usuario@dominio.com"/>
                            </div>
                        </div>
                    </Dialog>

                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default SendConfirmationView;